import Component from 'vue-class-component';
import {Prop, Vue} from 'vue-property-decorator';
import {Action, Getter} from 'vuex-class';
import {LoadingState, LoadingStateInterface} from '@/components/Loading/types';
import Loading from '@/components/Loading/index.vue';

/**
 * Component for generic content block
 *
 * @author nchapman@frontier.co.uk
 */
@Component({
  name: 'c-content-block',
  components: {
    'c-loading': Loading,
  },
})
export default class ContentBlock extends Vue {
  public state: LoadingStateInterface = new LoadingState(false, false);

  @Getter('getContentBlock', {namespace: 'contentStateModule'})
  public getContentBlock!: (slug: string) => ContentBlock | undefined;

  @Action('fetchBlocks', {namespace: 'contentStateModule'}) private fetchBocks: any;

  @Prop(String) private slug!: string;
  @Prop({default: true}) private description!: boolean;


  /**
   * Mounted lifecycle hook
   *
   * @return {Promise<void>}
   */
  public async mounted(): Promise<void> {
    try {
      this.state.start();
      await this.fetchBocks();
      this.state.complete();
    } catch (e) {
      this.state.failed(e.message);
    }
  }
}
